import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import NavigationProvider from './contexts/NavigationProvider';
import ContextProvider from './contexts/ContextProvider';
import TenantThemeProvider from './contexts/ThemeProvider';

import App from './App';
import { getTenantFromUrl } from './utils/tenant';

import './index.scss';

const container = document.getElementById('root');
const root = createRoot(container);
const hostname = window.location.hostname;
const cookieDomain = hostname === 'localhost'? hostname : hostname.split('.').slice(-2).join('.');
const isRedwoodSeed = getTenantFromUrl() === 'redwoodseed';
Amplify.configure({
  Auth: {
    // Live
    Cognito: {
      userPoolId: isRedwoodSeed
      ? process.env.REACT_APP_COGNITO_USER_POOL_ID_REDWOODSEED
      : process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: isRedwoodSeed
      ? process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID_REDWOODSEED
      : process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
      identityPoolId: isRedwoodSeed
      ? process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID_REDWOODSEED
      : process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    },
    // test
    // Redwoodseed
    // Cognito: {
    //   userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID_REDWOODSEED,
    //   userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID_REDWOODSEED,
    //   identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID_REDWOODSEED,
    // },
    // Initio
    // Cognito: {
    //   userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    //   userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
    //   identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    // },

  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ domain: cookieDomain }));
// cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ domain: process.env.REACT_APP_COOKIE_STORAGE_DOMAIN }));

// MUI Global Style Alterations
const muiGlobalTheme = createTheme({
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
        disableTouchRipple: true,
      },
    },
    MuiIconButton: {
      defaultProps: {
        disableFocusRipple: true,
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
  },
});

root.render(
  <React.StrictMode>
    <Router>
      <TenantThemeProvider>
        <ThemeProvider theme={muiGlobalTheme}>
          <NavigationProvider>
            <ContextProvider>
              <App />
            </ContextProvider>
          </NavigationProvider>
        </ThemeProvider>
      </TenantThemeProvider>
    </Router>
  </React.StrictMode>,
);
